import { UserStore } from './user.store';
import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from '../service/api.service';
import { SedeModel, ISedeModel } from '../interfaces/sedeModel';
import { SocketService } from '../service/socket.service';
import { AcuStorageService } from '../service/acustorage.service';


@Injectable({
  providedIn: 'root'
})
export class SediStore {
  public listaSediAttive: ISedeModel[] = [];
  public listaSediUffici: SedeModel[] = [];
  /** true dopo il primo caricamento (da rete o da cache offline) */
  public loaded = false;

  public storeUpdated: EventEmitter<void> = new EventEmitter();

  constructor(
    private apiService: ApiService,
    private socketService: SocketService,
    private userStore: UserStore,
    private storage: AcuStorageService
  ) {
    this.socketService.receiveUpdateSedi().subscribe((update) => {
      this.initStore();
    });
    this.socketService.updateStoreReconnected.subscribe(() => {
      console.log("updateStoreReconnected");
      if (this.userStore.userLogged) {
        this.initStore();
      }
    });

    this.userStore.storeUpdated.subscribe(() => {
      if (this.userStore.userLogged) {
        this.initStore();
      }
    });
  }

  public initStore() {
    console.log('SediStore - inizializzato');
    this.apiService.getAllSedi().subscribe({
      next: (sedi) => {
        if (sedi) {
          this.storage.setObjectInStorage('listaSediUffici', sedi);
        }
        this.processSedi(sedi);
      },
      error: (err) => {
        console.warn('SediStore - error fetching, attempting offline fallback', err);
        const cached = this.storage.getObjectInStorage<SedeModel[]>('listaSediUffici');
        if (cached) {
          this.processSedi(cached);
        }
      }
    });
  }

  /** Ricarica le sedi dal server e attende il completamento (usato dopo una modifica da admin). */
  public async reload(): Promise<void> {
    const sedi = await this.apiService.getAllSediPromise();
    if (sedi) {
      this.storage.setObjectInStorage('listaSediUffici', sedi);
    }
    this.processSedi(sedi);
  }

  private processSedi(sedi: SedeModel[]) {
    this.loaded = true;
    this.listaSediUffici = sedi || [];
    const newListaSediAttive: ISedeModel[] = [];

    if (sedi) {
      sedi.forEach(sede => {
        let sedeAttiva: ISedeModel = {
          id: sede.id,
          _id: sede._id,
          codice: sede.codice,
          descrizione: sede.descrizione,
          securityOfficerRequired: sede.securityOfficerRequired,
          secureCheckInRequired: sede.secureCheckInRequired,
          nfcTagUid: sede.nfcTagUid,
          maxBookingWeeks: sede.maxBookingWeeks
        };
        newListaSediAttive.push(sedeAttiva);
      });
    }
    this.listaSediAttive = newListaSediAttive;
    this.storeUpdated.emit();
  }

  public addSede(newSede: SedeModel) {
    console.log('add sede..');
    return this.apiService.insertSede(newSede);
  }

  updateSede(sede: SedeModel): Promise<any> {
    console.log('update sede..');
    return this.apiService.updateSede(sede);
  }

  deleteSede(sede: SedeModel): Promise<any> {
    console.log('delete sede..');
    return this.apiService.deleteSede(sede);
  }

  getSedeByCodice(codice: string): ISedeModel {
    return this.listaSediAttive.find(sede => sede.codice === codice)
  }

  getSedeUfficiByCodice(codice: string): ISedeModel {
    return this.listaSediUffici.find(sede => sede.codice === codice)
  }

}
